import React from 'react';
import Money from '../../../Components/Formatting/Money';
import { getEntityLink } from '../../../Services/helpers';
import Dropdown from '../../../Components/Dropdown';
import DateTime from '../../../Components/Formatting/DateTime';
import { useDialogues } from '../../../Components/Dialogues';
import { useSession } from '../../../Components/Session';

const ListView = ({payments, setOpenPayment, matchCustomer, unmatchCustomer, refundPayment, isEmpty, hasSearchConditions}) => {
    const {confirm} = useDialogues();
    const {isAdmin} = useSession();

    if (isEmpty) {
        return <p className="text-center text-muted text-sm mt-8 mx-auto max-w-[75%]">
            {hasSearchConditions ?
                'No payments match your search' :
                <>
                    There are no payments to display.<br /><br />
                    Try making your first payment - add yourself as a customer and choose 'View customer portal'.
                </>
            }
        </p>
    }

    return <>
        <ul className="divide-y divide-gray-200 mt-5">
            {payments.map((payment, i) => {
                return <li key={payment.id} className="flex flex-row gap-x-6 py-5 first:pt-0">
                    <div className="grow flex flex-row gap-x-6 cursor-pointer" onClick={() => setOpenPayment(payment.id)}>
                        <div className="text-lg font-bold shrink-0">
                            <Money pence={payment.pence} />
                        </div>
                        <div className="grow">
                            <p className="text-sm text-gray-900">
                                <strong>{payment.name}</strong><br />
                                <DateTime date={payment.completedAt ?? payment.startedAt} /><br />
                                <span className="text-muted">
                                    {payment.status} &nbsp; &bull; &nbsp; {payment.paymentMethod}
                                </span><br />
                                {!payment.customerId && <span className="text-red-600">No matching customer</span>}
                            </p>
                        </div>
                    </div>
                    <div className="shrink-0">
                        <Dropdown options={[
                            {
                                icon: 'User',
                                title: 'View customer',
                                to: getEntityLink('Customers/Customer', payment.customerId),
                                disabled: !payment.customerId,
                            },
                            {
                                div: true,
                            },
                            {
                                icon: 'UserMagnifyingGlass',
                                title: 'Match to customer',
                                disabled: payment.customerId,
                                onClick: () => matchCustomer(payment)
                            },
                            {
                                icon: 'UserSlash',
                                title: 'Remove from customer',
                                disabled: !payment.customerId,
                                onClick: () => unmatchCustomer(payment)
                            },
                            {
                                div: true,
                                hidden: !isAdmin(),
                            },
                            {
                                icon: 'Backward',
                                title: 'Refund',
                                disabled: !payment.canBeRefunded,
                                hidden: !isAdmin(),
                                onClick: () => confirm(
                                    {
                                        theme: 'danger',
                                        title: 'Refund payment',
                                        message: <>
                                            Are you sure you want to refund this payment?<br />
                                            This cannot be undone.<br />
                                            Your customer will receive the full amount back in 5-10 days, but due to cost incurred in processing payments we are unable to return the processing fees.
                                        </>,
                                        confirmLabel: 'Refund'
                                    },
                                    () => refundPayment(payment.id)
                                )
                            }
                        ]} />
                    </div>
                </li>
            })}
        </ul>
    </>
}

export default ListView;
